export interface UserPublicNameParts {
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
}

export const getUserPublicName = ({
  firstName,
  lastName,
  companyName,
}: UserPublicNameParts): string => {
  const normalizedCompanyName = companyName?.trim();
  if (normalizedCompanyName) {
    return normalizedCompanyName;
  }

  const fullName = [firstName, lastName]
    .map((value) => value?.trim())
    .filter((value): value is string => Boolean(value))
    .join(' ');

  return fullName || 'Utilizator roade.ro';
};
